import type { FilterConditionDTO } from "@/shared/contracts/base";
import {
  findCondition,
  removeConditions,
  upsertCondition,
} from "@/shared/contracts/query-helpers";
import { Button, Input, useDebounceCallback } from "@devhop/ui";
import { useNavigate, useSearch } from "@tanstack/react-router";
import { XIcon } from "lucide-react";
import { useEffect, useState } from "react";

export function OptionsFilter() {
  const nav = useNavigate({ from: "/app/catalog/options" });
  const search = useSearch({ from: "/app/catalog/options" }) as {
    limit?: number;
    offset?: number;
    sort?: Array<{ field: string; dir: "asc" | "desc" }> | string;
    filters?: FilterConditionDTO[] | string;
  };

  const filters = (search.filters as FilterConditionDTO[] | undefined) ?? [];
  const nameFilter = findCondition(filters, "nameLo");

  const [searchValue, setSearchValue] = useState<string>(
    (nameFilter?.value as string) || ""
  );

  useEffect(
    () => setSearchValue((nameFilter?.value as string) || ""),
    [nameFilter?.value]
  );

  const debounced = useDebounceCallback((val: string) => {
    setSearchValue(val);
    let nextFilters = removeConditions(filters, "nameLo") ?? [];
    if (val) {
      nextFilters = upsertCondition(nextFilters, {
        field: "nameLo",
        op: "contains",
        value: val,
      });
    }
    nav({
      search: {
        ...search,
        offset: 0,
        filters: nextFilters.length ? nextFilters : undefined,
      } as any,
    });
  }, 400);

  const hasFilter = Boolean(nameFilter?.value);

  return (
    <div className="mb-4 flex flex-wrap items-center gap-4 px-2">
      <Input
        placeholder="ຄົ້ນຫາ option (ຊື່ຫຼື slug)..."
        defaultValue={searchValue}
        onChange={(e) => debounced(e.target.value)}
        className="h-8 sm:max-w-2xs"
        data-tourid="catalog-options-search"
      />
      {hasFilter && (
        <Button
          variant="ghost"
          size="sm"
          onClick={() =>
            nav({
              search: {
                ...search,
                offset: 0,
                filters: undefined,
              } as any,
            })
          }
        >
          <XIcon className="h-4 w-4" /> Clear
        </Button>
      )}
    </div>
  );
}
